module.exports = __webpack_public_path__ + "img/gry_5.6a705622.png";